/**
 * Body for AddServiceOrderJobs request containing order ID and list of jobs to add.
 */
import { ServiceOrderJob } from '../order';

export class AddServiceOrderJobsRequestBody {
  /** Order number as assigned by the DMS. Required. */
  dmsServiceOrderId: string;

  /** BMW internal key to identify an order (GUID). */
  externalId?: string;

  /** List of Jobs to add. All jobs must have change status "New". */
  jobList: ServiceOrderJob[];
}

